import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'SpeciesView',
        component: () => import(/* webpackChunkName: 'SpeciesView' */ '@/views/SpeciesView'),
        meta: {
            progress: 0,
        },
    }, {
        path: '/:species',
        component: () => import(/* webpackChunkName: 'SpeciesLayout' */ '@/views/SpeciesLayout'),
        children: [{
            path: '',
            name: 'TissueView',
            component: () => import(/* webpackChunkName: 'TissueView' */ '@/views/TissueView'),
            meta: {
                progress: 1,
            },
        }, {
            path: '/:species/:tissue',
            name: 'PhenotypeView',
            component: () => import(/* webpackChunkName: 'PhenotypeView' */ '@/views/PhenotypeView'),
            meta: {
                progress: 2,
            },
        }, {
            path: '/:species/:tissue/:phenotype',
            name: 'SubsetView',
            component: () => import(/* webpackChunkName: 'SubsetView' */ '@/views/SubsetView'),
            meta: {
                progress: 3,
            },
        }],
    }],
})
